import * as Immutable from 'immutable';
import * as React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { searchDataById } from '../../../actions/Learn/SearchActions';
import { SearchResultsMain } from '../../../components/Learn/Search/SearchResultsMain';
import { SearchResultsVideo } from '../../../components/Learn/Search/SearchResultsVideo';
import { StateType } from '../../../reducers';
import { ResultsProps } from '../../../reducers/LearnReducer/SearchReducer/SearchReducer.types';
import { DispatchConnect } from '../../../types';

interface SearchResultsStateProps {
  results: Immutable.List<ResultsProps>;
  count: number;
  next: string;
  previous: string;
  currentPage: number;
}

interface QueryValues {
  queryTerm: string;
  queryFilters: string[];
}

interface SearchResultsDispatchers {
  dispatchSearchData: (id: string, pageNumber: number, offset: number, queryTerm: string) => void;
}

interface SearchResultsProps {
  title: string;
  modifiers?: string[];
  queryFilters: Immutable.List<string>;
  newTab?: boolean;
  queryTerm: string;
  id: 'recommendedReading' | 'reference' | 'tutorialPage' | 'video';
  // The pathname where the current Learn Component it is been displayed
  // Eg : in this route /simulate the value is simulate, for the route /learn the value is learn
  path: string;
  getQueryValues: () => QueryValues;
}
interface SearchResultsState {
  currentPage: number;
}

type SearchResultsGenericProps = SearchResultsProps & SearchResultsStateProps & SearchResultsDispatchers;

export class SearchResults extends React.Component<SearchResultsGenericProps, SearchResultsState> {
  pageSize = 3;

  constructor(props: SearchResultsGenericProps) {
    super(props);
    this.state = {
      currentPage: 0,
    };
  }

  changePrevPage = () => {
    this.changePage(this.props.currentPage - 1);
  };

  changeNextPage = () => {
    this.changePage(this.props.currentPage + 1);
  };

  changePage = (pageNumber: number) => {
    const { id } = this.props;
    this.props.dispatchSearchData(id, pageNumber, this.pageSize * pageNumber, this.props.queryTerm);
  };

  getPaginationNumbers = () => {
    const pageCount = Math.ceil(this.props.count / this.pageSize);
    const current = this.props.currentPage;
    const delta = 2;
    const left = current - delta;
    const right = current + delta + 1;
    const range = [];
    const rangeWithDots = [];
    let l = null;

    for (let i = 1; i <= pageCount; i = i + 1) {
      if (i === 1 || i === pageCount || (i >= left && i < right)) {
        range.push(i);
      }
    }

    for (const i of range) {
      if (l) {
        if (i - l === 2) {
          rangeWithDots.push(l + 1);
        } else if (i - l !== 1) {
          rangeWithDots.push('...');
        }
      }
      rangeWithDots.push(i);
      l = i;
    }

    return rangeWithDots;
  };
  render(): JSX.Element | null {
    const { title, results, modifiers, id, newTab, queryTerm, queryFilters } = this.props;
    const showPagination = this.props.count > this.pageSize;
    const resultSize = results ? results.size : 0;
    if (id === 'video' && queryFilters && (queryFilters.size === 0 || queryFilters.includes(id))) {
      return (
        <SearchResultsVideo
          data={results}
          title={title}
          queryTerm={queryTerm}
          count={this.props.count}
          changePrevPage={this.changePrevPage}
          changeNextPage={this.changeNextPage}
          getPaginationNumbers={this.getPaginationNumbers}
          changePage={this.changePage}
          pageSize={Math.min(this.pageSize, resultSize)}
          path={this.props.path}
          page={this.props.currentPage}
          pages={Math.ceil(this.props.count / this.pageSize)}
          showPagination={showPagination}
        />
      );
    } else if (queryFilters && (queryFilters.size === 0 || queryFilters.includes(id))) {
      return (
        <SearchResultsMain
          modifiers={modifiers ? modifiers : []}
          data={results}
          title={title}
          id={id}
          newTab={newTab}
          queryTerm={queryTerm}
          count={this.props.count}
          changePrevPage={this.changePrevPage}
          changeNextPage={this.changeNextPage}
          getPaginationNumbers={this.getPaginationNumbers}
          page={this.props.currentPage}
          pages={Math.ceil(this.props.count / this.pageSize)}
          changePage={this.changePage}
          pageSize={Math.min(this.pageSize, resultSize)}
          path={this.props.path}
          showPagination={showPagination}
        />
      );
    } else {
      return null;
    }
  }
}

const mapStateToProps = (state: StateType, props: SearchResultsProps): SearchResultsStateProps => ({
  // @ts-ignore
  results: state.getIn(['learn', 'search', props.id, 'results']),
  // @ts-ignore
  count: state.getIn(['learn', 'search', props.id, 'count']),
  // @ts-ignore
  next: state.getIn(['learn', 'search', props.id, 'next']),
  // @ts-ignore
  previous: state.getIn(['learn', 'search', props.id, 'previous']),
  // @ts-ignore
  currentPage: state.getIn(['learn', 'search', props.id, 'currentPage']),
});

const mapDispatchToProps = (dispatch: Dispatch<any>): SearchResultsDispatchers => ({
  dispatchSearchData: async (id: string, pageNumber: number, offset: number, queryTerm: string) =>
    dispatch(searchDataById(id, pageNumber, offset, queryTerm)),
});

export default connect<SearchResultsStateProps, DispatchConnect<SearchResultsDispatchers>, any, StateType>(
  mapStateToProps,
  mapDispatchToProps
)(SearchResults);
